export default __webpack_public_path__ + "static/hiv-testing-26957153433b709fb389ad6fed9ce391.svg";